var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "event-details-box" }, [
    _c(
      "div",
      { staticClass: "event-registration-box" },
      [
        _c("payment-summary", {
          attrs: {
            formTitle: _vm.eventConfig["names-label-your-total"],
            priceTitle: "",
            products: _vm.products,
            donationPrice: _vm.donation,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "event-form-wrap event-box-shadow" }, [
      _c("div", { staticClass: "event-rg-form" }, [
        _c("h6", { staticClass: "mb-3" }, [
          _vm._v(_vm._s(_vm.eventConfig["payment-label-details"])),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-payment" },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12", class: _vm.classBtnGroup },
                [
                  _vm.showPaymentOptions
                    ? _c(
                        "el-button-group",
                        { staticClass: "toggle-options" },
                        [
                          _vm._l(_vm.paymentOptions, function (payment, i) {
                            return [
                              payment.active
                                ? _c(
                                    "el-button",
                                    {
                                      key: i,
                                      attrs: {
                                        type:
                                          _vm.activePaymentIndex === i
                                            ? "primary"
                                            : "plain",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.activePaymentIndex = i
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(payment.name) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.paymentOptions.length
              ? [
                  _c(
                    "keep-alive",
                    [
                      _c(_vm.paymentOptions[_vm.activePaymentIndex].component, {
                        tag: "component",
                        attrs: {
                          billingInfo: _vm.billingInfo,
                          eventConfig: _vm.eventConfig,
                        },
                        on: {
                          "back-step": _vm.onBackClick,
                          "next-step": _vm.onNextClick,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }